import { Link } from "react-router-dom";
import logo from '../../assets/ax_white.png';

export default function Logo() {
    return (
        <Link to="/">
            <img src={logo} alt="logo"/>
        </Link>
    )
}